var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _path, _path2, _path3, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _path4, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _path5, _path6, _path7, _g25, _g26, _g27, _path8, _path9, _path10, _path11, _g28, _g29, _g30, _path12, _path13, _path14, _path15, _g31, _g32, _g33, _g34, _g35, _g36, _path16, _path17, _path18, _g37, _g38, _g39, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _g40, _g41, _path27, _path28, _path29, _path30, _g42, _path31, _path32, _path33, _g43, _path34, _path35, _path36, _g44, _g45, _path37, _path38, _path39, _g46, _g47, _path40, _path41, _path42, _g48, _g49;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCookiePhase3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 1254.38 1485.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cookie-disable-rect{\n        fill: #edeef0;\n      }\n      .cookie-disable-rect:hover {\n        pointer-events: none;\n        fill: #edeef0;  \n      }\n      .cls-1-cookie-p3 {\n        fill: url(#cookie-linear-gradient3-p3);\n      }\n\n      .cls-1-cookie-p3, .cls-2-cookie-p3, .cls-3-cookie-p3, .cls-4-cookie-p3, .cls-5-cookie-p3, .cls-6-cookie-p3 {\n        stroke: #008573;\n      }\n\n      .cls-7-cookie-p3, .cls-8-cookie-p3, .cls-9-cookie-p3, .cls-10-cookie-p3, .cls-11-cookie-p3 {\n        stroke-width: 0px;\n      }\n\n      .cls-7-cookie-p3, .cls-2-cookie-p3, .cls-4-cookie-p3 {\n        fill: #008573;\n      }\n\n      .cls-12-cookie-p3 {\n        fill: url(#cookie-linear-gradient2-p3);\n        stroke: #1071e5;\n      }\n\n      .cls-2-cookie-p3 {\n        stroke-width: .05px;\n      }\n\n      .cls-3-cookie-p3 {\n        fill: url(#cookie-linear-gradient1-p3);\n      }\n\n      .cls-9-cookie-p3 {\n        fill: #333;\n      }\n\n      .cls-10-cookie-p3, .cls-5-cookie-p3 {\n        fill: #fff;\n      }\n\n      .cls-11-cookie-p3 {\n        fill: #3a414a;\n      }\n\n      .cls-6-cookie-p3 {\n        fill: none;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cookie-linear-gradient1-p3",
    x1: 20740.44,
    y1: 1888.55,
    x2: 20740.44,
    y2: 1746.15,
    gradientTransform: "translate(-20108.82 2089.05) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b8f5ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#00c2a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00c2a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008573"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cookie-linear-gradient2-p3",
    x1: 20202.14,
    y1: 1893.34,
    x2: 20202.14,
    y2: 1741.36,
    gradientTransform: "translate(-20108.82 2089.05) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#edf5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#cfe4ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1071e5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cookie-linear-gradient3-p3",
    x1: 20740.44,
    y1: 1308.55,
    x2: 20740.44,
    y2: 1166.15,
    gradientTransform: "translate(-20108.82 2089.05) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b8f5ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#00c2a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00c2a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008573"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "rect1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5-cookie-p3",
    d: "M460.5,6.5c0-3.31,2.69-6,6-6h330.25c3.31,0,6,2.69,6,6v100c0,3.31-2.69,6-6,6h-330.25c-3.31,0-6-2.69-6-6V6.5Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ac",
    className: "cls-11-cookie-p3",
    d: "M489.82,62.31v-16.84h2.31v16.84h-2.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad",
    className: "cls-11-cookie-p3",
    d: "M502.31,49.13c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ae",
    className: "cls-11-cookie-p3",
    d: "M509.58,46.62v-2.04h2.17v2.04h-2.17ZM509.58,62.31v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "af",
    className: "cls-11-cookie-p3",
    d: "M517.32,59.11c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ae-2",
    "data-name": "ae",
    className: "cls-11-cookie-p3",
    d: "M521.73,46.62v-2.04h2.17v2.04h-2.17ZM521.73,62.31v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ag",
    className: "cls-11-cookie-p3",
    d: "M535.04,59.86c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM528.72,58.71c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "af-2",
    "data-name": "af",
    className: "cls-11-cookie-p3",
    d: "M543.05,59.11c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ah",
    className: "cls-11-cookie-p3",
    d: "M552.63,49.13c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM556.16,54.63c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ai",
    className: "cls-11-cookie-p3",
    d: "M575.51,62.31h-2.31l-6.86-16.84h2.38l5.64,14.8,5.64-14.8h2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ai-2",
    "data-name": "ai",
    className: "cls-11-cookie-p3",
    d: "M591.8,62.31h-2.31l-6.86-16.84h2.38l5.64,14.8,5.64-14.8h2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aj",
    className: "cls-11-cookie-p3",
    d: "M600.83,45.47c5.91.07,12.97-1.02,12.97,5.09,0,5.3-5.23,5.43-10.73,5.16v6.59h-2.24v-16.84ZM603.08,53.95c3.87,0,8.42.75,8.42-3.4s-4.62-3.19-8.42-3.26v6.65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ak",
    className: "cls-11-cookie-p3",
    d: "M631.39,62.31l.14-14.8c-1.56,5.16-3.67,9.85-5.43,14.8h-1.56l-5.5-14.8.07,14.8h-1.97v-16.84h2.99l5.23,14.33c1.43-5.09,3.46-9.51,5.16-14.33h2.92v16.84h-2.04"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    id: "al",
    className: "cls-11-cookie-p3",
    d: "M644.22,62.31v-16.84h12.7v1.9h-10.46v5.36h9.78v1.83h-9.78v5.91h11v1.83h-13.24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "am",
    className: "cls-11-cookie-p3",
    d: "M668.06,62.31l-3.46-5.3-3.53,5.3h-2.31l4.62-6.65-4.41-6.25h2.38l3.26,5.02,3.19-5.02h2.38l-4.35,6.25,4.62,6.65h-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ag-2",
    "data-name": "ag",
    className: "cls-11-cookie-p3",
    d: "M680.28,59.86c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM673.97,58.71c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "an",
    className: "cls-11-cookie-p3",
    d: "M698.55,50.83c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ae-3",
    "data-name": "ae",
    className: "cls-11-cookie-p3",
    d: "M706.22,46.62v-2.04h2.17v2.04h-2.17ZM706.22,62.31v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad-2",
    "data-name": "ad",
    className: "cls-11-cookie-p3",
    d: "M717.9,49.13c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ag-3",
    "data-name": "ag",
    className: "cls-11-cookie-p3",
    d: "M733.11,59.86c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM726.79,58.71c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "af-3",
    "data-name": "af",
    className: "cls-11-cookie-p3",
    d: "M741.12,59.11c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ae-4",
    "data-name": "ae",
    className: "cls-11-cookie-p3",
    d: "M745.53,46.62v-2.04h2.17v2.04h-2.17ZM745.53,62.31v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ao",
    className: "cls-11-cookie-p3",
    d: "M756.06,49.13c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM755.99,60.95c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad-3",
    "data-name": "ad",
    className: "cls-11-cookie-p3",
    d: "M770.79,49.13c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "diamond1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3-cookie-p3",
    d: "M626.08,202.8c3.55-1.48,7.55-1.48,11.1,0l160.03,66.6c1.27.54,1.86,2.01,1.32,3.28-.25.59-.73,1.07-1.32,1.32l-160.04,66.6c-3.55,1.48-7.55,1.48-11.1,0l-160.04-66.6c-1.27-.54-1.86-2.01-1.32-3.28.25-.59.73-1.07,1.32-1.32l160.05-66.6Z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ap",
    className: "cls-10-cookie-p3",
    d: "M580.07,274.93l.14-13.85-4.35,13.85h-2.51l-4.28-13.85.14,13.85h-3.12v-16.84h4.75l3.8,12.56,3.87-12.56h4.69v16.84h-3.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aq",
    className: "cls-10-cookie-p3",
    d: "M586.39,274.93v-16.84h3.53v14.12h9.03v2.72h-12.56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ar",
    className: "cls-10-cookie-p3",
    d: "M615.92,263.12c0,2.72-1.56,4.14-3.67,4.75l4.55,7.06h-4.01l-3.87-6.38h-4.14v6.38h-3.53v-16.84c6.31.27,14.73-1.56,14.67,5.02ZM604.79,265.83c3.26-.14,7.6.81,7.6-2.58s-4.48-2.17-7.6-2.38v4.96"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    id: "as",
    className: "cls-10-cookie-p3",
    d: "M633.99,274.93h-3.6l-6.25-16.84h3.73l4.35,13.99c1.15-4.89,2.85-9.3,4.28-13.99h3.67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "at",
    className: "cls-10-cookie-p3",
    d: "M651.5,271.67c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27ZM648.45,266.99c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "au",
    className: "cls-10-cookie-p3",
    d: "M661.69,264.75c-2.65-.81-4.07.88-4.07,3.87v6.31h-3.4l-.07-12.9h3.19c.14.88-.07,1.97.2,2.72.41-1.9,1.83-3.6,4.14-2.78v2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "av",
    className: "cls-10-cookie-p3",
    d: "M668,261.76c2.1-.07,3.12,1.02,3.94,2.31l-.07-6.86h3.4l.07,17.72h-3.26c-.14-.68,0-1.56-.2-2.1-.75,1.56-1.97,2.38-4.14,2.38-3.53,0-4.62-3.06-4.69-6.72,0-3.8,1.29-6.59,4.96-6.72ZM669.16,272.89c2.24,0,2.72-2.04,2.78-4.48.07-2.51-.61-4.35-2.78-4.35s-2.58,2.04-2.65,4.41c0,2.92.88,4.41,2.65,4.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aw",
    className: "cls-10-cookie-p3",
    d: "M678.6,259.72v-2.51h3.4v2.51h-3.4ZM678.6,274.93v-12.9h3.4v12.9h-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ax",
    className: "cls-10-cookie-p3",
    d: "M696.59,270.65c-.48,2.85-2.58,4.55-5.84,4.55-4.01,0-5.7-2.58-6.11-6.65-.81-7.47,10.46-9.3,11.81-2.44l-3.33.14c-.14-1.29-1.02-2.17-2.38-2.17-2.04,0-2.38,1.9-2.58,4.35-.41,5.02,4.41,5.91,5.02,2.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ay",
    className: "cls-10-cookie-p3",
    d: "M705.08,274.73c-2.44.95-5.91.48-5.91-2.85v-7.6h-1.63v-2.24h1.83l1.02-3.06h2.1v3.06h2.44v2.24h-2.44v6.72c-.07,1.56,1.09,2.1,2.58,1.7v2.04"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-6-cookie-p3",
    d: "M631.63,113.5v73.18"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2-cookie-p3",
    d: "M632.13,113.51h-1v-.5h1v.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4-cookie-p3",
    d: "M631.63,201.45l-4.64-14.27h9.28l-4.64,14.27Z"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "rect2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5-cookie-p3",
    d: "M460.5,450.18c0-3.31,2.69-6,6-6h330.25c3.31,0,6,2.69,6,6v100c0,3.31-2.69,6-6,6h-330.25c-3.31,0-6-2.69-6-6v-100Z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    id: "al-2",
    "data-name": "al",
    className: "cls-11-cookie-p3",
    d: "M484.86,503.8v-16.84h12.7v1.9h-10.46v5.36h9.78v1.83h-9.78v5.91h11v1.83h-13.24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "az",
    className: "cls-11-cookie-p3",
    d: "M517.18,503.8h-2.72l-3.8-14.26-3.73,14.26h-2.72l-4.96-16.84h2.38l4.01,14.8,1.02-4.35,2.92-10.46h2.17l4.01,14.8,4.01-14.8h2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ac-2",
    "data-name": "ac",
    className: "cls-11-cookie-p3",
    d: "M524.38,503.8v-16.84h2.31v16.84h-2.31"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aA",
    className: "cls-11-cookie-p3",
    d: "M543.53,490.63c3.73.07,4.75,2.78,4.75,6.65s-1.09,6.65-4.75,6.79c-2.1,0-3.33-.88-4.07-2.31l.07,7.13h-2.17l-.07-17.99h2.1l.14,2.04c.68-1.43,1.9-2.31,4.01-2.31ZM542.98,502.44c2.72,0,3.06-2.31,3.06-5.09s-.41-4.96-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aB",
    className: "cls-11-cookie-p3",
    d: "M557.04,492.73c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ao-2",
    "data-name": "ao",
    className: "cls-11-cookie-p3",
    d: "M564.17,490.63c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM564.1,502.44c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aC",
    className: "cls-11-cookie-p3",
    d: "M578.29,503.8h-2.58l-4.69-12.9h2.31l3.67,11.2,3.8-11.2h2.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ae-5",
    "data-name": "ae",
    className: "cls-11-cookie-p3",
    d: "M584.81,488.11v-2.04h2.17v2.04h-2.17ZM584.81,503.8v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aD",
    className: "cls-11-cookie-p3",
    d: "M594.32,490.63c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM594.93,492.26c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ah-2",
    "data-name": "ah",
    className: "cls-11-cookie-p3",
    d: "M608.92,490.63c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM612.45,496.13c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aE",
    className: "cls-11-cookie-p3",
    d: "M624.87,494.09c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "j"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ad-4",
    "data-name": "ad",
    className: "cls-11-cookie-p3",
    d: "M642.66,490.63c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ah-3",
    "data-name": "ah",
    className: "cls-11-cookie-p3",
    d: "M655.09,490.63c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM658.62,496.13c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aF",
    className: "cls-11-cookie-p3",
    d: "M675.87,503.8h-2.44l-2.72-11.14-2.78,11.14h-2.44l-3.67-12.9h2.17l2.65,11.14,2.92-11.14h2.31l2.78,11.14,2.85-11.14h2.1"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "k"
  }, /*#__PURE__*/React.createElement("path", {
    id: "af-4",
    "data-name": "af",
    className: "cls-11-cookie-p3",
    d: "M690.26,500.61c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ah-4",
    "data-name": "ah",
    className: "cls-11-cookie-p3",
    d: "M699.84,490.63c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM703.37,496.13c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aE-2",
    "data-name": "aE",
    className: "cls-11-cookie-p3",
    d: "M715.79,494.09c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "af-5",
    "data-name": "af",
    className: "cls-11-cookie-p3",
    d: "M722.85,500.61c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "l"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aG",
    className: "cls-11-cookie-p3",
    d: "M734.06,503.8v-17.72h2.17v17.72h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ae-6",
    "data-name": "ae",
    className: "cls-11-cookie-p3",
    d: "M739.42,488.11v-2.04h2.17v2.04h-2.17ZM739.42,503.8v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad-5",
    "data-name": "ad",
    className: "cls-11-cookie-p3",
    d: "M751.1,490.63c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aH",
    className: "cls-11-cookie-p3",
    d: "M766.45,503.8l-4.35-5.91-1.56,1.29v4.62h-2.17v-17.72h2.17v11.07l5.64-6.25h2.51l-5.23,5.57,5.57,7.33h-2.58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aE-3",
    "data-name": "aE",
    className: "cls-11-cookie-p3",
    d: "M778.13,494.09c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "rect7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12-cookie-p3",
    d: "M.5,201.71c0-3.31,2.69-6,6-6h173.64c3.31,0,6,2.69,6,6v139.98c0,3.31-2.69,6-6,6H6.5c-3.31,0-6-2.69-6-6v-139.98Z"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "n"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aI",
    className: "cls-10-cookie-p3",
    d: "M33.72,265.59c-.07-2.92-6.38-3.12-6.59-.2,1.22,4.48,10.25.68,10.46,7.74.2,6.45-11.2,6.31-13.85,2.44-.41-.54-.68-1.29-.81-2.04l3.4-.54c.2,3.12,7.6,3.8,7.88.34-1.15-4.69-10.19-.68-10.46-7.74-.27-5.91,10.39-5.98,12.77-2.38.34.54.54,1.22.68,1.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "at-2",
    "data-name": "at",
    className: "cls-10-cookie-p3",
    d: "M51.1,274.69c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27ZM48.04,270.01c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "at-3",
    "data-name": "at",
    className: "cls-10-cookie-p3",
    d: "M64.68,274.69c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27ZM61.62,270.01c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "o"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aJ",
    className: "cls-10-cookie-p3",
    d: "M74.12,261.11c6.31.07,13.99-1.09,13.85,5.36-.07,5.09-4.69,5.98-10.32,5.57v5.91h-3.53v-16.84ZM77.65,269.33c3.19,0,6.79.48,6.79-2.78s-3.67-2.65-6.79-2.65v5.43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aK",
    className: "cls-10-cookie-p3",
    d: "M96.52,267.29c-4.01,0-2.31,6.59-2.65,10.66h-3.4v-17.72h3.4l-.07,7.4c.81-1.77,1.9-2.78,4.14-2.85,5.84-.07,3.94,7.67,4.28,13.17h-3.4c-.48-3.87,1.56-10.66-2.31-10.66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aL",
    className: "cls-10-cookie-p3",
    d: "M112.68,275.64c-1.09,1.29-2.04,2.65-4.35,2.58-2.51-.07-3.94-1.36-3.94-3.94-.07-4.07,3.73-4.28,7.88-4.14.07-1.77-.2-3.19-1.9-3.19-1.22.07-1.77.61-1.9,1.83l-3.53-.14c.48-2.58,2.44-3.94,5.57-3.87s5.02,1.49,5.09,4.62l.07,5.57c-.07.95.81,1.22,1.7,1.02v1.83c-2.04.54-4.82.34-4.69-2.17ZM109.42,275.84c1.97,0,2.92-1.63,2.85-3.87-2.17,0-4.48-.2-4.41,2.04,0,1.15.54,1.83,1.56,1.83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aM",
    className: "cls-10-cookie-p3",
    d: "M126.54,268.58c.07-1.97-4.75-2.31-4.82-.27,1.02,3.12,8.01.48,8.08,5.84.07,5.64-11.14,5.16-11.68.61l2.92-.48c.27,1.29,1.36,1.7,2.99,1.7,2.24.54,3.87-2.04,1.63-2.78-2.92-.95-6.93-.75-7.06-4.48-.14-5.43,10.46-5.02,10.93-.48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "at-4",
    "data-name": "at",
    className: "cls-10-cookie-p3",
    d: "M143.38,274.69c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27ZM140.32,270.01c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "p"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aN",
    className: "cls-10-cookie-p3",
    d: "M152.75,277.95v-2.51h4.14v-11.48l-4.01,2.51v-2.58l4.21-2.78h3.12v14.33h3.87v2.51h-11.34"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cookie-disable-rect",
    d: "M1068.24,218.83c0-3.31,2.69-6,6-6h173.64c3.31,0,6,2.69,6,6v115.33c0,3.31-2.69,6-6,6h-173.64c-3.31,0-6-2.69-6-6v-115.33Z"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "q"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aO",
    className: "cls-11-cookie-p3",
    d: "M1116.66,228.92c-.68-1.9-2.38-3.06-4.96-3.06-4.01,0-5.91,2.72-5.91,6.72s1.97,6.86,6.04,6.86c2.92,0,4.21-1.63,5.3-3.53l1.83.95c-1.22,2.58-3.46,4.48-7.27,4.48-5.43,0-7.94-3.4-8.22-8.76-.41-7.06,6.72-10.39,12.7-7.54,1.29.61,2.1,1.77,2.65,3.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ao-3",
    "data-name": "ao",
    className: "cls-11-cookie-p3",
    d: "M1126.64,227.9c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM1126.57,239.71c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "an-2",
    "data-name": "an",
    className: "cls-11-cookie-p3",
    d: "M1147.69,229.6c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "an-3",
    "data-name": "an",
    className: "cls-11-cookie-p3",
    d: "M1167.99,229.6c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ah-5",
    "data-name": "ah",
    className: "cls-11-cookie-p3",
    d: "M1180.83,227.9c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM1184.36,233.4c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad-6",
    "data-name": "ad",
    className: "cls-11-cookie-p3",
    d: "M1195.56,227.9c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "af-6",
    "data-name": "af",
    className: "cls-11-cookie-p3",
    d: "M1205.2,237.88c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aE-4",
    "data-name": "aE",
    className: "cls-11-cookie-p3",
    d: "M1217.15,231.36c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "r"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aE-5",
    "data-name": "aE",
    className: "cls-11-cookie-p3",
    d: "M1103.93,260.69c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aP",
    className: "cls-11-cookie-p3",
    d: "M1112.69,270.68c-6.04.27-3.67-7.88-4.14-13.17h2.17v8.15c0,2.1.48,3.4,2.65,3.33,4.89-.14,3.06-6.86,3.4-11.48h2.1l.07,12.9h-2.04c-.07-.68.07-1.7-.14-2.24-.75,1.49-1.9,2.44-4.07,2.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aQ",
    className: "cls-11-cookie-p3",
    d: "M1128.37,257.23c3.6,0,4.69,2.65,4.75,6.65,0,4.48-1.56,6.79-4.75,6.79-2.1-.07-3.33-.75-4.01-2.31l-.14,2.04h-2.1l.07-17.72h2.17v6.86c.68-1.56,1.9-2.31,4.01-2.31ZM1127.83,269.05c2.72,0,3.06-2.31,3.06-5.09s-.34-5.09-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "an-4",
    "data-name": "an",
    className: "cls-11-cookie-p3",
    d: "M1148.41,258.93c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ae-7",
    "data-name": "ae",
    className: "cls-11-cookie-p3",
    d: "M1156.08,254.72v-2.04h2.17v2.04h-2.17ZM1156.08,270.4v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "af-7",
    "data-name": "af",
    className: "cls-11-cookie-p3",
    d: "M1163.82,267.21c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "af-8",
    "data-name": "af",
    className: "cls-11-cookie-p3",
    d: "M1170.61,267.21c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ah-6",
    "data-name": "ah",
    className: "cls-11-cookie-p3",
    d: "M1180.18,257.23c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM1183.71,262.73c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aD-2",
    "data-name": "aD",
    className: "cls-11-cookie-p3",
    d: "M1192.75,257.23c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM1193.36,258.86c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "s"
  }, /*#__PURE__*/React.createElement("path", {
    id: "af-9",
    "data-name": "af",
    className: "cls-11-cookie-p3",
    d: "M1211.35,267.21c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ao-4",
    "data-name": "ao",
    className: "cls-11-cookie-p3",
    d: "M1220.92,257.23c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM1220.86,269.05c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "t"
  }, /*#__PURE__*/React.createElement("path", {
    id: "al-3",
    "data-name": "al",
    className: "cls-11-cookie-p3",
    d: "M1083.97,299.74v-16.84h12.7v1.9h-10.46v5.36h9.78v1.83h-9.78v5.91h11v1.83h-13.24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "az-2",
    "data-name": "az",
    className: "cls-11-cookie-p3",
    d: "M1116.29,299.74h-2.72l-3.8-14.26-3.73,14.26h-2.72l-4.96-16.84h2.38l4.01,14.8,1.02-4.35,2.92-10.46h2.17l4.01,14.8,4.01-14.8h2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ac-3",
    "data-name": "ac",
    className: "cls-11-cookie-p3",
    d: "M1123.49,299.74v-16.84h2.31v16.84h-2.31"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "u"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aR",
    className: "cls-11-cookie-p3",
    d: "M1141.68,283.85c-2.1-.61-2.85.68-2.58,2.99h2.58v1.56h-2.58v11.34h-2.1v-11.34h-1.83v-1.56h1.83c-.48-3.53,1.15-5.57,4.69-4.62v1.63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ao-5",
    "data-name": "ao",
    className: "cls-11-cookie-p3",
    d: "M1148.4,286.56c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM1148.34,298.38c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aB-2",
    "data-name": "aB",
    className: "cls-11-cookie-p3",
    d: "M1162.94,288.67c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "v"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aR-2",
    "data-name": "aR",
    className: "cls-11-cookie-p3",
    d: "M1176.92,283.85c-2.1-.61-2.85.68-2.58,2.99h2.58v1.56h-2.58v11.34h-2.1v-11.34h-1.83v-1.56h1.83c-.48-3.53,1.15-5.57,4.69-4.62v1.63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aP-2",
    "data-name": "aP",
    className: "cls-11-cookie-p3",
    d: "M1182.56,300.01c-6.04.27-3.67-7.88-4.14-13.17h2.17v8.15c0,2.1.48,3.4,2.65,3.33,4.89-.14,3.06-6.86,3.4-11.48h2.1l.07,12.9h-2.04c-.07-.68.07-1.7-.14-2.24-.75,1.49-1.9,2.44-4.07,2.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aB-3",
    "data-name": "aB",
    className: "cls-11-cookie-p3",
    d: "M1198.18,288.67c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "af-10",
    "data-name": "af",
    className: "cls-11-cookie-p3",
    d: "M1202.52,296.55c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aS",
    className: "cls-11-cookie-p3",
    d: "M1212.5,288.26c-4.89,0-2.99,6.93-3.33,11.48h-2.17v-17.72h2.17l-.07,6.99c.81-1.43,1.9-2.44,4.14-2.44,6.04,0,3.6,7.88,4.07,13.17h-2.17v-8.22c.14-2.17-.54-3.33-2.65-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ah-7",
    "data-name": "ah",
    className: "cls-11-cookie-p3",
    d: "M1225.68,286.56c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM1229.21,292.06c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aB-4",
    "data-name": "aB",
    className: "cls-11-cookie-p3",
    d: "M1240.21,288.67c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "w"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ag-4",
    "data-name": "ag",
    className: "cls-11-cookie-p3",
    d: "M1127.39,326.63c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM1121.08,325.47c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "an-5",
    "data-name": "an",
    className: "cls-11-cookie-p3",
    d: "M1145.66,317.6c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ah-8",
    "data-name": "ah",
    className: "cls-11-cookie-p3",
    d: "M1158.49,315.9c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM1162.02,321.4c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad-7",
    "data-name": "ad",
    className: "cls-11-cookie-p3",
    d: "M1173.22,315.9c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aD-3",
    "data-name": "aD",
    className: "cls-11-cookie-p3",
    d: "M1184.63,315.9c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM1185.24,317.53c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aE-6",
    "data-name": "aE",
    className: "cls-11-cookie-p3",
    d: "M1201.61,319.36c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2-cookie-p3",
    d: "M246.3,272.2h-43.27v-1h43.27v1ZM466.66,272.2h-59.16v-1h59.16v1ZM470.16,272.2h-3.5v-1h3.5v1Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7-cookie-p3",
    d: "M202.53,276.35l-14.27-4.65,14.27-4.63v9.28Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2-cookie-p3",
    d: "M203.03,277.02l-16.4-5.32,16.4-5.32v10.64ZM189.88,271.7l12.15,3.95v-7.9l-12.15,3.95Z"
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "x"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aT",
    className: "cls-8-cookie-p3",
    d: "M303.85,250.11c0,2.72-1.56,4.14-3.67,4.75l4.55,7.06h-4.01l-3.87-6.38h-4.14v6.38h-3.53v-16.84c6.31.27,14.73-1.56,14.67,5.02ZM292.72,252.82c3.26-.14,7.6.81,7.6-2.58s-4.48-2.17-7.6-2.38v4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aU",
    className: "cls-8-cookie-p3",
    d: "M317.7,258.66c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27ZM314.65,253.98c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aV",
    className: "cls-8-cookie-p3",
    d: "M327.41,261.92h-4.01l-4.62-12.9h3.6l3.06,10.19,3.26-10.19h3.53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aW",
    className: "cls-8-cookie-p3",
    d: "M334,246.71v-2.51h3.4v2.51h-3.4ZM334,261.92v-12.9h3.4v12.9h-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aX",
    className: "cls-8-cookie-p3",
    d: "M348.4,252.55c.07-1.97-4.75-2.31-4.82-.27,1.02,3.12,8.01.48,8.08,5.84.07,5.64-11.14,5.16-11.68.61l2.92-.48c.27,1.29,1.36,1.7,2.99,1.7,2.24.54,3.87-2.04,1.63-2.78-2.92-.95-6.93-.75-7.06-4.48-.14-5.43,10.46-5.02,10.93-.48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aU-2",
    "data-name": "aU",
    className: "cls-8-cookie-p3",
    d: "M365.24,258.66c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27ZM362.18,253.98c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "y"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aY",
    className: "cls-8-cookie-p3",
    d: "M255.34,288.95c-1.09,1.29-2.04,2.65-4.35,2.58-2.51-.07-3.94-1.36-3.94-3.94-.07-4.07,3.73-4.28,7.88-4.14.07-1.77-.2-3.19-1.9-3.19-1.22.07-1.77.61-1.9,1.83l-3.53-.14c.48-2.58,2.44-3.94,5.57-3.87s5.02,1.49,5.09,4.62l.07,5.57c-.07.95.81,1.22,1.7,1.02v1.83c-2.04.54-4.82.34-4.69-2.17ZM252.08,289.15c1.97,0,2.92-1.63,2.85-3.87-2.17,0-4.48-.2-4.41,2.04,0,1.15.54,1.83,1.56,1.83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aZ",
    className: "cls-8-cookie-p3",
    d: "M269.05,278.08c5.91-.07,3.94,7.67,4.28,13.17h-3.4c-.48-3.87,1.56-10.66-2.31-10.66s-2.31,6.59-2.65,10.66h-3.4l-.07-12.9h3.19c.14.81-.07,1.9.2,2.58.81-1.77,1.9-2.78,4.14-2.85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ba",
    className: "cls-8-cookie-p3",
    d: "M280.73,278.08c2.1-.07,3.12,1.02,3.94,2.31l-.07-6.86h3.4l.07,17.72h-3.26c-.14-.68,0-1.56-.2-2.1-.75,1.56-1.97,2.38-4.14,2.38-3.53,0-4.62-3.06-4.69-6.72,0-3.8,1.29-6.59,4.96-6.72ZM281.89,289.22c2.24,0,2.72-2.04,2.78-4.48.07-2.51-.61-4.35-2.78-4.35s-2.58,2.04-2.65,4.41c0,2.92.88,4.41,2.65,4.41"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "z"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aT-2",
    "data-name": "aT",
    className: "cls-8-cookie-p3",
    d: "M312.71,279.44c0,2.72-1.56,4.14-3.67,4.75l4.55,7.06h-4.01l-3.87-6.38h-4.14v6.38h-3.53v-16.84c6.31.27,14.73-1.56,14.67,5.02ZM301.58,282.16c3.26-.14,7.6.81,7.6-2.58s-4.48-2.17-7.6-2.38v4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aU-3",
    "data-name": "aU",
    className: "cls-8-cookie-p3",
    d: "M326.56,288c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27ZM323.51,283.31c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aX-2",
    "data-name": "aX",
    className: "cls-8-cookie-p3",
    d: "M336.89,281.89c.07-1.97-4.75-2.31-4.82-.27,1.02,3.12,8.01.48,8.08,5.84.07,5.64-11.14,5.16-11.68.61l2.92-.48c.27,1.29,1.36,1.7,2.99,1.7,2.24.54,3.87-2.04,1.63-2.78-2.92-.95-6.93-.75-7.06-4.48-.14-5.43,10.46-5.02,10.93-.48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bb",
    className: "cls-8-cookie-p3",
    d: "M346.93,291.53c-5.91.07-3.94-7.67-4.28-13.17h3.4c.48,3.87-1.56,10.19,2.24,10.66,4.07-.34,2.38-6.59,2.72-10.66h3.4l.07,12.9h-3.19c-.14-.81.07-1.9-.2-2.58-.81,1.7-1.9,2.85-4.14,2.85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bc",
    className: "cls-8-cookie-p3",
    d: "M365.2,278.08c3.53,0,4.75,2.92,4.75,6.65s-1.29,6.72-4.96,6.79c-2.04.07-3.12-1.02-3.94-2.38l-.14,2.1h-3.26l.07-17.72h3.4v7.06c.75-1.56,1.97-2.51,4.07-2.51ZM363.77,289.22c2.1,0,2.72-1.83,2.72-4.48s-.48-4.28-2.65-4.28-2.78,1.9-2.78,4.41.54,4.35,2.72,4.35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bd",
    className: "cls-8-cookie-p3",
    d: "M385.84,280.6c-3.6.61-1.9,6.79-2.31,10.66h-3.33v-7.27c.07-1.83-.34-3.33-1.97-3.4-3.6.68-1.83,6.79-2.24,10.66h-3.4l-.07-12.9h3.19c.14.81-.07,1.9.2,2.58.68-3.6,6.86-3.8,7.33,0,.88-1.49,1.63-2.92,4.01-2.85,5.57.07,3.46,7.88,3.87,13.17h-3.33v-7.27c-.07-1.7-.34-3.26-1.97-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aW-2",
    "data-name": "aW",
    className: "cls-8-cookie-p3",
    d: "M394.33,276.05v-2.51h3.4v2.51h-3.4ZM394.33,291.26v-12.9h3.4v12.9h-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "be",
    className: "cls-8-cookie-p3",
    d: "M407.23,291.05c-2.44.95-5.91.48-5.91-2.85v-7.6h-1.63v-2.24h1.83l1.02-3.06h2.1v3.06h2.44v2.24h-2.44v6.72c-.07,1.56,1.09,2.1,2.58,1.7v2.04"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2-cookie-p3",
    d: "M1051.36,275.99v1h-42.2v-1h42.2ZM796.6,272.19v-1h58.08v1h-58.08Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2-cookie-p3",
    d: "M796.61,272.2h-3.5v-1h3.5v1Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7-cookie-p3",
    d: "M1066.12,276.49l-14.26,4.64v-9.27l14.26,4.63Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2-cookie-p3",
    d: "M1067.74,276.49l-16.38,5.33v-10.65l16.38,5.32ZM1052.36,280.44l12.14-3.96-12.14-3.94v7.9Z"
  })), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "A"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bf",
    className: "cls-8-cookie-p3",
    d: "M888.57,264.32l-1.49-4.28h-6.38l-1.49,4.28h-3.53l6.11-16.84h4.14l6.11,16.84h-3.46ZM886.33,257.39l-2.44-7.33c-.68,2.58-1.63,4.89-2.44,7.33h4.89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bg",
    className: "cls-8-cookie-p3",
    d: "M901.81,251.15c3.6,0,4.75,2.99,4.75,6.65s-1.29,6.65-4.96,6.79c-2.1.07-3.06-1.15-4.01-2.31.2,2.24.14,4.69.14,7.13h-3.4l-.07-17.99h3.26c.14.68,0,1.56.2,2.1.75-1.63,1.97-2.38,4.07-2.38ZM900.38,262.28c2.24,0,2.65-2.1,2.72-4.48,0-2.58-.61-4.35-2.72-4.35-3.8,0-3.73,8.83,0,8.83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bg-2",
    "data-name": "bg",
    className: "cls-8-cookie-p3",
    d: "M916.68,251.15c3.6,0,4.75,2.99,4.75,6.65s-1.29,6.65-4.96,6.79c-2.1.07-3.06-1.15-4.01-2.31.2,2.24.14,4.69.14,7.13h-3.4l-.07-17.99h3.26c.14.68,0,1.56.2,2.1.75-1.63,1.97-2.38,4.07-2.38ZM915.25,262.28c2.24,0,2.65-2.1,2.72-4.48,0-2.58-.61-4.35-2.72-4.35-3.8,0-3.73,8.83,0,8.83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bh",
    className: "cls-8-cookie-p3",
    d: "M931.55,254.13c-2.65-.81-4.07.88-4.07,3.87v6.31h-3.4l-.07-12.9h3.19c.14.88-.07,1.97.2,2.72.41-1.9,1.83-3.6,4.14-2.78v2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bi",
    className: "cls-8-cookie-p3",
    d: "M939.36,251.15c4.35,0,6.52,2.44,6.52,6.72s-2.38,6.72-6.59,6.72-6.45-2.44-6.45-6.72,2.31-6.72,6.52-6.72ZM939.29,262.28c2.38,0,3.06-1.9,3.06-4.41,0-2.72-.68-4.41-2.92-4.41s-3.06,1.77-3.06,4.41c0,2.44.68,4.41,2.92,4.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aV-2",
    "data-name": "aV",
    className: "cls-8-cookie-p3",
    d: "M955.45,264.32h-4.01l-4.62-12.9h3.6l3.06,10.19,3.26-10.19h3.53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aU-4",
    "data-name": "aU",
    className: "cls-8-cookie-p3",
    d: "M972.9,261.06c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27ZM969.85,256.37c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ba-2",
    "data-name": "ba",
    className: "cls-8-cookie-p3",
    d: "M979.9,251.15c2.1-.07,3.12,1.02,3.94,2.31l-.07-6.86h3.4l.07,17.72h-3.26c-.14-.68,0-1.56-.2-2.1-.75,1.56-1.97,2.38-4.14,2.38-3.53,0-4.62-3.06-4.69-6.72,0-3.8,1.29-6.59,4.96-6.72ZM981.05,262.28c2.24,0,2.72-2.04,2.78-4.48.07-2.51-.61-4.35-2.78-4.35s-2.58,2.04-2.65,4.41c0,2.92.88,4.41,2.65,4.41"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "B"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bj",
    className: "cls-8-cookie-p3",
    d: "M870.37,293.65h-3.53l-2.65-10.52-2.72,10.52h-3.53l-3.33-12.9h3.12l2.17,9.85c.61-3.53,1.63-6.59,2.44-9.85h3.6l2.51,9.85,2.17-9.85h3.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aW-3",
    "data-name": "aW",
    className: "cls-8-cookie-p3",
    d: "M875.4,278.44v-2.51h3.4v2.51h-3.4ZM875.4,293.65v-12.9h3.4v12.9h-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "be-2",
    "data-name": "be",
    className: "cls-8-cookie-p3",
    d: "M888.3,293.45c-2.44.95-5.91.48-5.91-2.85v-7.6h-1.63v-2.24h1.83l1.02-3.06h2.1v3.06h2.44v2.24h-2.44v6.72c-.07,1.56,1.09,2.1,2.58,1.7v2.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bk",
    className: "cls-8-cookie-p3",
    d: "M896.31,282.99c-4.01,0-2.31,6.59-2.65,10.66h-3.4v-17.72h3.4l-.07,7.4c.81-1.77,1.9-2.78,4.14-2.85,5.84-.07,3.94,7.67,4.28,13.17h-3.4c-.48-3.87,1.56-10.66-2.31-10.66"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "C"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bl",
    className: "cls-8-cookie-p3",
    d: "M923.13,289.37c-.48,2.85-2.58,4.55-5.84,4.55-4.01,0-5.7-2.58-6.11-6.65-.81-7.47,10.46-9.3,11.81-2.44l-3.33.14c-.14-1.29-1.02-2.17-2.38-2.17-2.04,0-2.38,1.9-2.58,4.35-.41,5.02,4.41,5.91,5.02,2.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bk-2",
    "data-name": "bk",
    className: "cls-8-cookie-p3",
    d: "M931.55,282.99c-4.01,0-2.31,6.59-2.65,10.66h-3.4v-17.72h3.4l-.07,7.4c.81-1.77,1.9-2.78,4.14-2.85,5.84-.07,3.94,7.67,4.28,13.17h-3.4c-.48-3.87,1.56-10.66-2.31-10.66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aY-2",
    "data-name": "aY",
    className: "cls-8-cookie-p3",
    d: "M947.71,291.34c-1.09,1.29-2.04,2.65-4.35,2.58-2.51-.07-3.94-1.36-3.94-3.94-.07-4.07,3.73-4.28,7.88-4.14.07-1.77-.2-3.19-1.9-3.19-1.22.07-1.77.61-1.9,1.83l-3.53-.14c.48-2.58,2.44-3.94,5.57-3.87s5.02,1.49,5.09,4.62l.07,5.57c-.07.95.81,1.22,1.7,1.02v1.83c-2.04.54-4.82.34-4.69-2.17ZM944.45,291.55c1.97,0,2.92-1.63,2.85-3.87-2.17,0-4.48-.2-4.41,2.04,0,1.15.54,1.83,1.56,1.83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aZ-2",
    "data-name": "aZ",
    className: "cls-8-cookie-p3",
    d: "M961.43,280.48c5.91-.07,3.94,7.67,4.28,13.17h-3.4c-.48-3.87,1.56-10.66-2.31-10.66s-2.31,6.59-2.65,10.66h-3.4l-.07-12.9h3.19c.14.81-.07,1.9.2,2.58.81-1.77,1.9-2.78,4.14-2.85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bm",
    className: "cls-8-cookie-p3",
    d: "M980.37,293.25c.75,5.98-8.15,7.2-11.14,3.53-.27-.41-.41-.88-.54-1.43l3.33-.41c.2,1.09,1.09,1.63,2.31,1.7,2.72,0,2.85-2.51,2.72-5.36-.75,1.49-2.04,2.38-4.14,2.38-3.6,0-4.75-2.92-4.75-6.59s1.22-6.52,4.96-6.59c2.04,0,3.12.95,4.01,2.31l.14-2.04h3.19l-.07,12.49ZM974.26,291.28c2.17,0,2.78-1.83,2.78-4.28s-.61-4.21-2.72-4.21-2.65,1.97-2.72,4.28c0,2.44.61,4.21,2.65,4.21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aU-5",
    "data-name": "aU",
    className: "cls-8-cookie-p3",
    d: "M994.56,290.39c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27ZM991.51,285.71c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aX-3",
    "data-name": "aX",
    className: "cls-8-cookie-p3",
    d: "M1004.88,284.28c.07-1.97-4.75-2.31-4.82-.27,1.02,3.12,8.01.48,8.08,5.84.07,5.64-11.14,5.16-11.68.61l2.92-.48c.27,1.29,1.36,1.7,2.99,1.7,2.24.54,3.87-2.04,1.63-2.78-2.92-.95-6.93-.75-7.06-4.48-.14-5.43,10.46-5.02,10.93-.48"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2-cookie-p3",
    d: "M632.13,427.3h-1v-19.3h1v19.3ZM632.13,376h-1v-35.16h1v35.16Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2-cookie-p3",
    d: "M632.13,340.85h-1v-3.5h1v3.5Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7-cookie-p3",
    d: "M631.63,442.05l-4.64-14.25h9.28l-4.64,14.25Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2-cookie-p3",
    d: "M631.63,443.68l-5.33-16.38h10.65l-5.32,16.38ZM627.68,428.3l3.95,12.15,3.94-12.15h-7.89Z"
  })), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "D"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bn",
    className: "cls-9-cookie-p3",
    d: "M489.08,397.34l-1.63-4.67h-6.96l-1.63,4.67h-3.85l6.67-18.37h4.52l6.67,18.37h-3.78ZM486.63,389.79l-2.67-8c-.74,2.81-1.78,5.33-2.67,8h5.33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bo",
    className: "cls-9-cookie-p3",
    d: "M503.52,382.97c3.93,0,5.19,3.26,5.19,7.26s-1.41,7.26-5.41,7.41c-2.3.07-3.33-1.26-4.37-2.52.22,2.44.15,5.11.15,7.78h-3.7l-.07-19.63h3.56c.15.74,0,1.7.22,2.3.81-1.78,2.15-2.59,4.44-2.59ZM501.97,395.12c2.44,0,2.89-2.3,2.96-4.89,0-2.81-.67-4.74-2.96-4.74-4.15,0-4.07,9.63,0,9.63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bo-2",
    "data-name": "bo",
    className: "cls-9-cookie-p3",
    d: "M519.75,382.97c3.93,0,5.19,3.26,5.19,7.26s-1.41,7.26-5.41,7.41c-2.3.07-3.33-1.26-4.37-2.52.22,2.44.15,5.11.15,7.78h-3.7l-.07-19.63h3.56c.15.74,0,1.7.22,2.3.81-1.78,2.15-2.59,4.44-2.59ZM518.19,395.12c2.44,0,2.89-2.3,2.96-4.89,0-2.81-.67-4.74-2.96-4.74-4.15,0-4.07,9.63,0,9.63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bp",
    className: "cls-9-cookie-p3",
    d: "M535.97,386.23c-2.89-.89-4.44.96-4.44,4.22v6.89h-3.7l-.07-14.07h3.48c.15.96-.07,2.15.22,2.96.44-2.07,2-3.93,4.52-3.04v3.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bq",
    className: "cls-9-cookie-p3",
    d: "M544.49,382.97c4.74,0,7.11,2.67,7.11,7.33s-2.59,7.33-7.19,7.33-7.04-2.67-7.04-7.33,2.52-7.33,7.11-7.33ZM544.41,395.12c2.59,0,3.33-2.07,3.33-4.81,0-2.96-.74-4.81-3.19-4.81s-3.33,1.93-3.33,4.81c0,2.67.74,4.81,3.19,4.81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "br",
    className: "cls-9-cookie-p3",
    d: "M562.04,397.34h-4.37l-5.04-14.07h3.93l3.33,11.11,3.56-11.11h3.85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bs",
    className: "cls-9-cookie-p3",
    d: "M581.08,393.79c-.96,2.22-2.74,3.93-6.07,3.85-4.44-.15-6.59-2.74-6.59-7.41s2.22-7.26,6.67-7.26,6.15,3.33,6.22,8h-9.04c0,2.3.59,4.07,2.89,4.15,1.33,0,2.22-.52,2.52-1.63l3.41.3ZM577.75,388.68c.37-3.41-4.22-4.67-5.19-1.56-.15.44-.3.96-.3,1.56h5.48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bt",
    className: "cls-9-cookie-p3",
    d: "M588.71,382.97c2.3-.07,3.41,1.11,4.3,2.52l-.07-7.48h3.7l.07,19.33h-3.56c-.15-.74,0-1.7-.22-2.3-.81,1.7-2.15,2.59-4.52,2.59-3.85,0-5.04-3.33-5.11-7.33,0-4.15,1.41-7.19,5.41-7.33ZM589.97,395.12c2.44,0,2.96-2.22,3.04-4.89.07-2.74-.67-4.74-3.04-4.74s-2.81,2.22-2.89,4.81c0,3.19.96,4.81,2.89,4.81"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "E"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bu",
    className: "cls-9-cookie-p3",
    d: "M614.78,380.6c-2-.52-3.19.37-2.81,2.67h2.81v2.44h-2.81v11.63h-3.63v-11.63h-2.07v-2.44h2.07c-.67-4.37,2.37-6,6.44-5.04v2.37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bq-2",
    "data-name": "bq",
    className: "cls-9-cookie-p3",
    d: "M622.78,382.97c4.74,0,7.11,2.67,7.11,7.33s-2.59,7.33-7.19,7.33-7.04-2.67-7.04-7.33,2.52-7.33,7.11-7.33ZM622.71,395.12c2.59,0,3.33-2.07,3.33-4.81,0-2.96-.74-4.81-3.19-4.81s-3.33,1.93-3.33,4.81c0,2.67.74,4.81,3.19,4.81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bp-2",
    "data-name": "bp",
    className: "cls-9-cookie-p3",
    d: "M640.86,386.23c-2.89-.89-4.44.96-4.44,4.22v6.89h-3.7l-.07-14.07h3.48c.15.96-.07,2.15.22,2.96.44-2.07,2-3.93,4.52-3.04v3.04"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "F"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bv",
    className: "cls-9-cookie-p3",
    d: "M650.41,378.97c6.89.07,15.26-1.19,15.11,5.85-.07,5.56-5.11,6.52-11.26,6.07v6.44h-3.85v-18.37ZM654.26,387.94c3.48,0,7.41.52,7.41-3.04s-4-2.89-7.41-2.89v5.93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bp-3",
    "data-name": "bp",
    className: "cls-9-cookie-p3",
    d: "M676.41,386.23c-2.89-.89-4.44.96-4.44,4.22v6.89h-3.7l-.07-14.07h3.48c.15.96-.07,2.15.22,2.96.44-2.07,2-3.93,4.52-3.04v3.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bq-3",
    "data-name": "bq",
    className: "cls-9-cookie-p3",
    d: "M684.93,382.97c4.74,0,7.11,2.67,7.11,7.33s-2.59,7.33-7.19,7.33-7.04-2.67-7.04-7.33,2.52-7.33,7.11-7.33ZM684.86,395.12c2.59,0,3.33-2.07,3.33-4.81,0-2.96-.74-4.81-3.19-4.81s-3.33,1.93-3.33,4.81c0,2.67.74,4.81,3.19,4.81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bt-2",
    "data-name": "bt",
    className: "cls-9-cookie-p3",
    d: "M699.52,382.97c2.3-.07,3.41,1.11,4.3,2.52l-.07-7.48h3.7l.07,19.33h-3.56c-.15-.74,0-1.7-.22-2.3-.81,1.7-2.15,2.59-4.52,2.59-3.85,0-5.04-3.33-5.11-7.33,0-4.15,1.41-7.19,5.41-7.33ZM700.78,395.12c2.44,0,2.96-2.22,3.04-4.89.07-2.74-.67-4.74-3.04-4.74s-2.81,2.22-2.89,4.81c0,3.19.96,4.81,2.89,4.81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bw",
    className: "cls-9-cookie-p3",
    d: "M715.52,397.64c-6.44.07-4.3-8.37-4.67-14.37h3.7c.52,4.22-1.7,11.11,2.44,11.63,4.44-.37,2.59-7.19,2.96-11.63h3.7l.07,14.07h-3.48c-.15-.89.07-2.07-.22-2.81-.89,1.85-2.07,3.11-4.52,3.11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bx",
    className: "cls-9-cookie-p3",
    d: "M739.52,392.68c-.52,3.11-2.81,4.96-6.37,4.96-4.37,0-6.22-2.81-6.67-7.26-.89-8.15,11.41-10.15,12.89-2.67l-3.63.15c-.15-1.41-1.11-2.37-2.59-2.37-2.22,0-2.59,2.07-2.81,4.74-.44,5.48,4.81,6.44,5.48,2.22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "by",
    className: "cls-9-cookie-p3",
    d: "M748.78,397.12c-2.67,1.04-6.44.52-6.44-3.11v-8.3h-1.78v-2.44h2l1.11-3.33h2.3v3.33h2.67v2.44h-2.67v7.33c-.07,1.7,1.19,2.3,2.81,1.85v2.22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bz",
    className: "cls-9-cookie-p3",
    d: "M750.93,380.75v-2.74h3.7v2.74h-3.7ZM750.93,397.34v-14.07h3.7v14.07h-3.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bq-4",
    "data-name": "bq",
    className: "cls-9-cookie-p3",
    d: "M764.63,382.97c4.74,0,7.11,2.67,7.11,7.33s-2.59,7.33-7.19,7.33-7.04-2.67-7.04-7.33,2.52-7.33,7.11-7.33ZM764.56,395.12c2.59,0,3.33-2.07,3.33-4.81,0-2.96-.74-4.81-3.19-4.81s-3.33,1.93-3.33,4.81c0,2.67.74,4.81,3.19,4.81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bA",
    className: "cls-9-cookie-p3",
    d: "M782.71,382.97c6.44-.07,4.3,8.37,4.67,14.37h-3.7c-.52-4.22,1.7-11.63-2.52-11.63s-2.52,7.19-2.89,11.63h-3.7l-.07-14.07h3.48c.15.89-.07,2.07.22,2.81.89-1.93,2.07-3.04,4.52-3.11"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "rect3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5-cookie-p3",
    d: "M460.5,628.45c0-3.31,2.69-6,6-6h330.25c3.31,0,6,2.69,6,6v100c0,3.31-2.69,6-6,6h-330.25c-3.31,0-6-2.69-6-6v-100Z"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "a-2",
    "data-name": "a"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ac-4",
    "data-name": "ac",
    className: "cls-11-cookie-p3",
    d: "M530.59,682.06v-16.84h2.31v16.84h-2.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad-8",
    "data-name": "ad",
    className: "cls-11-cookie-p3",
    d: "M543.09,668.88c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ae-8",
    "data-name": "ae",
    className: "cls-11-cookie-p3",
    d: "M550.35,666.37v-2.04h2.17v2.04h-2.17ZM550.35,682.06v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "af-11",
    "data-name": "af",
    className: "cls-11-cookie-p3",
    d: "M558.09,678.86c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ae-9",
    "data-name": "ae",
    className: "cls-11-cookie-p3",
    d: "M562.51,666.37v-2.04h2.17v2.04h-2.17ZM562.51,682.06v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ag-5",
    "data-name": "ag",
    className: "cls-11-cookie-p3",
    d: "M575.81,679.61c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM569.5,678.46c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "af-12",
    "data-name": "af",
    className: "cls-11-cookie-p3",
    d: "M583.83,678.86c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ah-9",
    "data-name": "ah",
    className: "cls-11-cookie-p3",
    d: "M593.4,668.88c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM596.93,674.38c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "G"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aO-2",
    "data-name": "aO",
    className: "cls-11-cookie-p3",
    d: "M621.38,669.9c-.68-1.9-2.38-3.06-4.96-3.06-4.01,0-5.91,2.72-5.91,6.72s1.97,6.86,6.04,6.86c2.92,0,4.21-1.63,5.3-3.53l1.83.95c-1.22,2.58-3.46,4.48-7.27,4.48-5.43,0-7.94-3.4-8.22-8.76-.41-7.06,6.72-10.39,12.7-7.54,1.29.61,2.1,1.77,2.65,3.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ah-10",
    "data-name": "ah",
    className: "cls-11-cookie-p3",
    d: "M631.36,668.88c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM634.89,674.38c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aB-5",
    "data-name": "aB",
    className: "cls-11-cookie-p3",
    d: "M645.89,670.99c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "af-13",
    "data-name": "af",
    className: "cls-11-cookie-p3",
    d: "M650.23,678.86c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ae-10",
    "data-name": "ae",
    className: "cls-11-cookie-p3",
    d: "M654.65,666.37v-2.04h2.17v2.04h-2.17ZM654.65,682.06v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aR-3",
    "data-name": "aR",
    className: "cls-11-cookie-p3",
    d: "M665.24,666.17c-2.1-.61-2.85.68-2.58,2.99h2.58v1.56h-2.58v11.34h-2.1v-11.34h-1.83v-1.56h1.83c-.48-3.53,1.15-5.57,4.69-4.62v1.63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ae-11",
    "data-name": "ae",
    className: "cls-11-cookie-p3",
    d: "M666.8,666.37v-2.04h2.17v2.04h-2.17ZM666.8,682.06v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bB",
    className: "cls-11-cookie-p3",
    d: "M677.05,670.58c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ag-6",
    "data-name": "ag",
    className: "cls-11-cookie-p3",
    d: "M692.33,679.61c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM686.02,678.46c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "af-14",
    "data-name": "af",
    className: "cls-11-cookie-p3",
    d: "M700.34,678.86c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ae-12",
    "data-name": "ae",
    className: "cls-11-cookie-p3",
    d: "M704.76,666.37v-2.04h2.17v2.04h-2.17ZM704.76,682.06v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ao-6",
    "data-name": "ao",
    className: "cls-11-cookie-p3",
    d: "M715.28,668.88c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM715.22,680.7c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad-9",
    "data-name": "ad",
    className: "cls-11-cookie-p3",
    d: "M730.02,668.88c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6-cookie-p3",
    d: "M631.63,557.18v48.37"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2-cookie-p3",
    d: "M632.13,557.19h-1v-.5h1v.5Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4-cookie-p3",
    d: "M631.63,620.32l-4.65-14.27h9.28l-4.63,14.27Z"
  })), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "diamond2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1-cookie-p3",
    d: "M626.08,782.8c3.55-1.48,7.55-1.48,11.1,0l160.03,66.6c1.27.54,1.86,2.01,1.32,3.28-.25.59-.73,1.07-1.32,1.32l-160.04,66.6c-3.55,1.48-7.55,1.48-11.1,0l-160.04-66.6c-1.27-.54-1.86-2.01-1.32-3.28.25-.59.73-1.07,1.32-1.32l160.05-66.6Z"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    id: "I"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bC",
    className: "cls-10-cookie-p3",
    d: "M520.9,846.44c0,3.6,1.43,5.91,4.96,5.98,2.51.07,3.67-1.49,4.41-3.19l3.06,1.15c-1.15,2.85-3.46,4.82-7.47,4.82-5.57,0-8.15-3.12-8.49-8.76-.48-7.47,7.4-10.59,13.31-7.27,1.22.68,1.97,1.97,2.44,3.4l-3.12.81c-.54-1.7-2.04-2.78-4.21-2.78-3.53,0-4.82,2.31-4.89,5.84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "at-5",
    "data-name": "at",
    className: "cls-10-cookie-p3",
    d: "M546.49,851.67c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27ZM543.44,846.99c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "au-2",
    "data-name": "au",
    className: "cls-10-cookie-p3",
    d: "M556.68,844.75c-2.65-.81-4.07.88-4.07,3.87v6.31h-3.4l-.07-12.9h3.19c.14.88-.07,1.97.2,2.72.41-1.9,1.83-3.6,4.14-2.78v2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ay-2",
    "data-name": "ay",
    className: "cls-10-cookie-p3",
    d: "M564.83,854.73c-2.44.95-5.91.48-5.91-2.85v-7.6h-1.63v-2.24h1.83l1.02-3.06h2.1v3.06h2.44v2.24h-2.44v6.72c-.07,1.56,1.09,2.1,2.58,1.7v2.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aw-2",
    "data-name": "aw",
    className: "cls-10-cookie-p3",
    d: "M566.8,839.72v-2.51h3.4v2.51h-3.4ZM566.8,854.93v-12.9h3.4v12.9h-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bD",
    className: "cls-10-cookie-p3",
    d: "M580.1,839.59c-1.83-.48-2.92.34-2.58,2.44h2.58v2.24h-2.58v10.66h-3.33v-10.66h-1.9v-2.24h1.9c-.61-4.01,2.17-5.5,5.91-4.62v2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aw-3",
    "data-name": "aw",
    className: "cls-10-cookie-p3",
    d: "M581.67,839.72v-2.51h3.4v2.51h-3.4ZM581.67,854.93v-12.9h3.4v12.9h-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ax-2",
    "data-name": "ax",
    className: "cls-10-cookie-p3",
    d: "M599.66,850.65c-.48,2.85-2.58,4.55-5.84,4.55-4.01,0-5.7-2.58-6.11-6.65-.81-7.47,10.46-9.3,11.81-2.44l-3.33.14c-.14-1.29-1.02-2.17-2.38-2.17-2.04,0-2.38,1.9-2.58,4.35-.41,5.02,4.41,5.91,5.02,2.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aL-2",
    "data-name": "aL",
    className: "cls-10-cookie-p3",
    d: "M609.37,852.62c-1.09,1.29-2.04,2.65-4.35,2.58-2.51-.07-3.94-1.36-3.94-3.94-.07-4.07,3.73-4.28,7.88-4.14.07-1.77-.2-3.19-1.9-3.19-1.22.07-1.77.61-1.9,1.83l-3.53-.14c.48-2.58,2.44-3.94,5.57-3.87s5.02,1.49,5.09,4.62l.07,5.57c-.07.95.81,1.22,1.7,1.02v1.83c-2.04.54-4.82.34-4.69-2.17ZM606.11,852.83c1.97,0,2.92-1.63,2.85-3.87-2.17,0-4.48-.2-4.41,2.04,0,1.15.54,1.83,1.56,1.83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ay-3",
    "data-name": "ay",
    className: "cls-10-cookie-p3",
    d: "M621.73,854.73c-2.44.95-5.91.48-5.91-2.85v-7.6h-1.63v-2.24h1.83l1.02-3.06h2.1v3.06h2.44v2.24h-2.44v6.72c-.07,1.56,1.09,2.1,2.58,1.7v2.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aw-4",
    "data-name": "aw",
    className: "cls-10-cookie-p3",
    d: "M623.7,839.72v-2.51h3.4v2.51h-3.4ZM623.7,854.93v-12.9h3.4v12.9h-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bE",
    className: "cls-10-cookie-p3",
    d: "M636.26,841.76c4.35,0,6.52,2.44,6.52,6.72s-2.38,6.72-6.59,6.72-6.45-2.44-6.45-6.72,2.31-6.72,6.52-6.72ZM636.19,852.89c2.38,0,3.06-1.9,3.06-4.41,0-2.72-.68-4.41-2.92-4.41s-3.06,1.77-3.06,4.41c0,2.44.68,4.41,2.92,4.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bF",
    className: "cls-10-cookie-p3",
    d: "M652.83,841.76c5.91-.07,3.94,7.67,4.28,13.17h-3.4c-.48-3.87,1.56-10.66-2.31-10.66s-2.31,6.59-2.65,10.66h-3.4l-.07-12.9h3.19c.14.81-.07,1.9.2,2.58.81-1.77,1.9-2.78,4.14-2.85"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    id: "J"
  }, /*#__PURE__*/React.createElement("path", {
    id: "as-2",
    "data-name": "as",
    className: "cls-10-cookie-p3",
    d: "M675.3,854.93h-3.6l-6.25-16.84h3.73l4.35,13.99c1.15-4.89,2.85-9.3,4.28-13.99h3.67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "at-6",
    "data-name": "at",
    className: "cls-10-cookie-p3",
    d: "M692.82,851.67c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27ZM689.77,846.99c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "au-3",
    "data-name": "au",
    className: "cls-10-cookie-p3",
    d: "M703.01,844.75c-2.65-.81-4.07.88-4.07,3.87v6.31h-3.4l-.07-12.9h3.19c.14.88-.07,1.97.2,2.72.41-1.9,1.83-3.6,4.14-2.78v2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "av-2",
    "data-name": "av",
    className: "cls-10-cookie-p3",
    d: "M709.32,841.76c2.1-.07,3.12,1.02,3.94,2.31l-.07-6.86h3.4l.07,17.72h-3.26c-.14-.68,0-1.56-.2-2.1-.75,1.56-1.97,2.38-4.14,2.38-3.53,0-4.62-3.06-4.69-6.72,0-3.8,1.29-6.59,4.96-6.72ZM710.48,852.89c2.24,0,2.72-2.04,2.78-4.48.07-2.51-.61-4.35-2.78-4.35s-2.58,2.04-2.65,4.41c0,2.92.88,4.41,2.65,4.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aw-5",
    "data-name": "aw",
    className: "cls-10-cookie-p3",
    d: "M719.91,839.72v-2.51h3.4v2.51h-3.4ZM719.91,854.93v-12.9h3.4v12.9h-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ax-3",
    "data-name": "ax",
    className: "cls-10-cookie-p3",
    d: "M737.91,850.65c-.48,2.85-2.58,4.55-5.84,4.55-4.01,0-5.7-2.58-6.11-6.65-.81-7.47,10.46-9.3,11.81-2.44l-3.33.14c-.14-1.29-1.02-2.17-2.38-2.17-2.04,0-2.38,1.9-2.58,4.35-.41,5.02,4.41,5.91,5.02,2.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ay-4",
    "data-name": "ay",
    className: "cls-10-cookie-p3",
    d: "M746.4,854.73c-2.44.95-5.91.48-5.91-2.85v-7.6h-1.63v-2.24h1.83l1.02-3.06h2.1v3.06h2.44v2.24h-2.44v6.72c-.07,1.56,1.09,2.1,2.58,1.7v2.04"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6-cookie-p3",
    d: "M631.63,735.45v31.23"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2-cookie-p3",
    d: "M632.13,735.45h-1v-.5h1v.5Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4-cookie-p3",
    d: "M631.63,781.45l-4.64-14.27h9.28l-4.64,14.27Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2-cookie-p3",
    d: "M93.82,672.42l.07.88.2.84.34.78.45.74.55.66.66.56.75.45.8.32.83.2.88.07h149.88v1H99.31l-1-.1-1-.23-.93-.4-.88-.52-.78-.67-.66-.77-.53-.86-.4-.94-.23-1-.08-1v-307.87h1v307.86ZM459.5,677.94v1h-68.1v-1h68.1Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7-cookie-p3",
    d: "M460,678.95h-.5v-1h.5v1Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2-cookie-p3",
    d: "M460.03,678.95h-.57v-1.04h.57v1.04ZM459.51,677.95v.96h.47v-.95h-.47Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7-cookie-p3",
    d: "M97.96,364.08h-9.27l4.64-14.27,4.63,14.27Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2-cookie-p3",
    d: "M98.65,364.58h-10.65l5.32-16.4,5.33,16.4ZM89.37,363.58h7.9l-3.96-12.15-3.94,12.15Z"
  })), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    id: "K"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bG",
    className: "cls-8-cookie-p3",
    d: "M261.11,683.33l-7.33-12.97c.41,3.94.14,8.69.2,12.97h-3.12v-16.84h4.01l7.47,13.1c-.41-3.94-.14-8.76-.2-13.1h3.12v16.84h-4.14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bi-2",
    "data-name": "bi",
    className: "cls-8-cookie-p3",
    d: "M274.28,670.15c4.35,0,6.52,2.44,6.52,6.72s-2.38,6.72-6.59,6.72-6.45-2.44-6.45-6.72,2.31-6.72,6.52-6.72ZM274.21,681.29c2.38,0,3.06-1.9,3.06-4.41,0-2.72-.68-4.41-2.92-4.41s-3.06,1.77-3.06,4.41c0,2.44.68,4.41,2.92,4.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "be-3",
    "data-name": "be",
    className: "cls-8-cookie-p3",
    d: "M289.49,683.12c-2.44.95-5.91.48-5.91-2.85v-7.6h-1.63v-2.24h1.83l1.02-3.06h2.1v3.06h2.44v2.24h-2.44v6.72c-.07,1.56,1.09,2.1,2.58,1.7v2.04"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    id: "L"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bl-2",
    "data-name": "bl",
    className: "cls-8-cookie-p3",
    d: "M309.45,679.05c-.48,2.85-2.58,4.55-5.84,4.55-4.01,0-5.7-2.58-6.11-6.65-.81-7.47,10.46-9.3,11.81-2.44l-3.33.14c-.14-1.29-1.02-2.17-2.38-2.17-2.04,0-2.38,1.9-2.58,4.35-.41,5.02,4.41,5.91,5.02,2.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aU-6",
    "data-name": "aU",
    className: "cls-8-cookie-p3",
    d: "M322.69,680.07c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27ZM319.64,675.38c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bh-2",
    "data-name": "bh",
    className: "cls-8-cookie-p3",
    d: "M332.88,673.14c-2.65-.81-4.07.88-4.07,3.87v6.31h-3.4l-.07-12.9h3.19c.14.88-.07,1.97.2,2.72.41-1.9,1.83-3.6,4.14-2.78v2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "be-4",
    "data-name": "be",
    className: "cls-8-cookie-p3",
    d: "M341.02,683.12c-2.44.95-5.91.48-5.91-2.85v-7.6h-1.63v-2.24h1.83l1.02-3.06h2.1v3.06h2.44v2.24h-2.44v6.72c-.07,1.56,1.09,2.1,2.58,1.7v2.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aW-4",
    "data-name": "aW",
    className: "cls-8-cookie-p3",
    d: "M342.99,668.12v-2.51h3.4v2.51h-3.4ZM342.99,683.33v-12.9h3.4v12.9h-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bH",
    className: "cls-8-cookie-p3",
    d: "M356.3,667.98c-1.83-.48-2.92.34-2.58,2.44h2.58v2.24h-2.58v10.66h-3.33v-10.66h-1.9v-2.24h1.9c-.61-4.01,2.17-5.5,5.91-4.62v2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aW-5",
    "data-name": "aW",
    className: "cls-8-cookie-p3",
    d: "M357.86,668.12v-2.51h3.4v2.51h-3.4ZM357.86,683.33v-12.9h3.4v12.9h-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aU-7",
    "data-name": "aU",
    className: "cls-8-cookie-p3",
    d: "M375.52,680.07c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27ZM372.46,675.38c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ba-3",
    "data-name": "ba",
    className: "cls-8-cookie-p3",
    d: "M382.51,670.15c2.1-.07,3.12,1.02,3.94,2.31l-.07-6.86h3.4l.07,17.72h-3.26c-.14-.68,0-1.56-.2-2.1-.75,1.56-1.97,2.38-4.14,2.38-3.53,0-4.62-3.06-4.69-6.72,0-3.8,1.29-6.59,4.96-6.72ZM383.67,681.29c2.24,0,2.72-2.04,2.78-4.48.07-2.51-.61-4.35-2.78-4.35s-2.58,2.04-2.65,4.41c0,2.92.88,4.41,2.65,4.41"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2-cookie-p3",
    d: "M890.28,852.2h-93.68v-1h93.7l-.02,1ZM1197.78,357.05l-.02,255.62-.1.08v232.97l-.08,1-.24,1-.4.93-.52.87-.66.78-.78.66-.87.54-.94.4-1,.23-1,.08h-54.2v-1h54.16l.88-.07.84-.2.8-.33.73-.45.67-.56.56-.66.45-.73.33-.8.2-.84.08-.87v-233.45l.1-.07.02-255.14h.99Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2-cookie-p3",
    d: "M796.61,852.2h-3.5v-1h3.5v1Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7-cookie-p3",
    d: "M1201.91,356.55h-9.27l4.64-14.27,4.63,14.27Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2-cookie-p3",
    d: "M1202.6,357.05h-10.64l5.32-16.4,5.32,16.4ZM1193.33,356.05h7.9l-3.95-12.15-3.95,12.15Z"
  })), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "M"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aT-3",
    "data-name": "aT",
    className: "cls-8-cookie-p3",
    d: "M906.59,844.77c0,2.72-1.56,4.14-3.67,4.75l4.55,7.06h-4.01l-3.87-6.38h-4.14v6.38h-3.53v-16.84c6.31.27,14.73-1.56,14.67,5.02ZM895.46,847.49c3.26-.14,7.6.81,7.6-2.58s-4.48-2.17-7.6-2.38v4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aU-8",
    "data-name": "aU",
    className: "cls-8-cookie-p3",
    d: "M920.45,853.33c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27ZM917.39,848.64c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aV-3",
    "data-name": "aV",
    className: "cls-8-cookie-p3",
    d: "M930.15,856.59h-4.01l-4.62-12.9h3.6l3.06,10.19,3.26-10.19h3.53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aW-6",
    "data-name": "aW",
    className: "cls-8-cookie-p3",
    d: "M936.74,841.38v-2.51h3.4v2.51h-3.4ZM936.74,856.59v-12.9h3.4v12.9h-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aX-4",
    "data-name": "aX",
    className: "cls-8-cookie-p3",
    d: "M951.14,847.22c.07-1.97-4.75-2.31-4.82-.27,1.02,3.12,8.01.48,8.08,5.84.07,5.64-11.14,5.16-11.68.61l2.92-.48c.27,1.29,1.36,1.7,2.99,1.7,2.24.54,3.87-2.04,1.63-2.78-2.92-.95-6.93-.75-7.06-4.48-.14-5.43,10.46-5.02,10.93-.48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aU-9",
    "data-name": "aU",
    className: "cls-8-cookie-p3",
    d: "M967.98,853.33c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27ZM964.92,848.64c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  })), /*#__PURE__*/React.createElement("g", {
    id: "N"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aY-3",
    "data-name": "aY",
    className: "cls-8-cookie-p3",
    d: "M984.81,854.28c-1.09,1.29-2.04,2.65-4.35,2.58-2.51-.07-3.94-1.36-3.94-3.94-.07-4.07,3.73-4.28,7.88-4.14.07-1.77-.2-3.19-1.9-3.19-1.22.07-1.77.61-1.9,1.83l-3.53-.14c.48-2.58,2.44-3.94,5.57-3.87s5.02,1.49,5.09,4.62l.07,5.57c-.07.95.81,1.22,1.7,1.02v1.83c-2.04.54-4.82.34-4.69-2.17ZM981.55,854.48c1.97,0,2.92-1.63,2.85-3.87-2.17,0-4.48-.2-4.41,2.04,0,1.15.54,1.83,1.56,1.83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aZ-3",
    "data-name": "aZ",
    className: "cls-8-cookie-p3",
    d: "M998.53,843.42c5.91-.07,3.94,7.67,4.28,13.17h-3.4c-.48-3.87,1.56-10.66-2.31-10.66s-2.31,6.59-2.65,10.66h-3.4l-.07-12.9h3.19c.14.81-.07,1.9.2,2.58.81-1.77,1.9-2.78,4.14-2.85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ba-4",
    "data-name": "ba",
    className: "cls-8-cookie-p3",
    d: "M1010.21,843.42c2.1-.07,3.12,1.02,3.94,2.31l-.07-6.86h3.4l.07,17.72h-3.26c-.14-.68,0-1.56-.2-2.1-.75,1.56-1.97,2.38-4.14,2.38-3.53,0-4.62-3.06-4.69-6.72,0-3.8,1.29-6.59,4.96-6.72ZM1011.36,854.55c2.24,0,2.72-2.04,2.78-4.48.07-2.51-.61-4.35-2.78-4.35s-2.58,2.04-2.65,4.41c0,2.92.88,4.41,2.65,4.41"
  })), /*#__PURE__*/React.createElement("g", {
    id: "O"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aT-4",
    "data-name": "aT",
    className: "cls-8-cookie-p3",
    d: "M1042.19,844.77c0,2.72-1.56,4.14-3.67,4.75l4.55,7.06h-4.01l-3.87-6.38h-4.14v6.38h-3.53v-16.84c6.31.27,14.73-1.56,14.67,5.02ZM1031.06,847.49c3.26-.14,7.6.81,7.6-2.58s-4.48-2.17-7.6-2.38v4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aU-10",
    "data-name": "aU",
    className: "cls-8-cookie-p3",
    d: "M1056.04,853.33c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27ZM1052.99,848.64c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aX-5",
    "data-name": "aX",
    className: "cls-8-cookie-p3",
    d: "M1066.36,847.22c.07-1.97-4.75-2.31-4.82-.27,1.02,3.12,8.01.48,8.08,5.84.07,5.64-11.14,5.16-11.68.61l2.92-.48c.27,1.29,1.36,1.7,2.99,1.7,2.24.54,3.87-2.04,1.63-2.78-2.92-.95-6.93-.75-7.06-4.48-.14-5.43,10.46-5.02,10.93-.48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bb-2",
    "data-name": "bb",
    className: "cls-8-cookie-p3",
    d: "M1076.41,856.86c-5.91.07-3.94-7.67-4.28-13.17h3.4c.48,3.87-1.56,10.19,2.24,10.66,4.07-.34,2.38-6.59,2.72-10.66h3.4l.07,12.9h-3.19c-.14-.81.07-1.9-.2-2.58-.81,1.7-1.9,2.85-4.14,2.85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bc-2",
    "data-name": "bc",
    className: "cls-8-cookie-p3",
    d: "M1094.68,843.42c3.53,0,4.75,2.92,4.75,6.65s-1.29,6.72-4.96,6.79c-2.04.07-3.12-1.02-3.94-2.38l-.14,2.1h-3.26l.07-17.72h3.4v7.06c.75-1.56,1.97-2.51,4.07-2.51ZM1093.25,854.55c2.1,0,2.72-1.83,2.72-4.48s-.48-4.28-2.65-4.28-2.78,1.9-2.78,4.41.54,4.35,2.72,4.35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bd-2",
    "data-name": "bd",
    className: "cls-8-cookie-p3",
    d: "M1115.32,845.93c-3.6.61-1.9,6.79-2.31,10.66h-3.33v-7.27c.07-1.83-.34-3.33-1.97-3.4-3.6.68-1.83,6.79-2.24,10.66h-3.4l-.07-12.9h3.19c.14.81-.07,1.9.2,2.58.68-3.6,6.86-3.8,7.33,0,.88-1.49,1.63-2.92,4.01-2.85,5.57.07,3.46,7.88,3.87,13.17h-3.33v-7.27c-.07-1.7-.34-3.26-1.97-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aW-7",
    "data-name": "aW",
    className: "cls-8-cookie-p3",
    d: "M1123.81,841.38v-2.51h3.4v2.51h-3.4ZM1123.81,856.59v-12.9h3.4v12.9h-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "be-5",
    "data-name": "be",
    className: "cls-8-cookie-p3",
    d: "M1136.71,856.39c-2.44.95-5.91.48-5.91-2.85v-7.6h-1.63v-2.24h1.83l1.02-3.06h2.1v3.06h2.44v2.24h-2.44v6.72c-.07,1.56,1.09,2.1,2.58,1.7v2.04"
  })))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2-cookie-p3",
    d: "M632.13,992.47h-1v-21.42h1v21.42ZM632.13,941.72h-1v-20.87h1v20.87ZM632.13,920.85h-1v-3.5h1v3.5Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7-cookie-p3",
    d: "M631.63,1007.23l-4.64-14.26h9.28l-4.64,14.26Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2-cookie-p3",
    d: "M631.63,1008.85l-5.33-16.38h10.65l-5.32,16.38ZM627.68,993.47l3.95,12.14,3.94-12.14h-7.89Z"
  })), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    id: "P"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bI",
    className: "cls-9-cookie-p3",
    d: "M586.75,952.79c0,3.6,1.43,5.91,4.96,5.98,2.51.07,3.67-1.49,4.41-3.19l3.06,1.15c-1.15,2.85-3.46,4.82-7.47,4.82-5.57,0-8.15-3.12-8.49-8.76-.48-7.47,7.4-10.59,13.31-7.27,1.22.68,1.97,1.97,2.44,3.4l-3.12.81c-.54-1.7-2.04-2.78-4.21-2.78-3.53,0-4.82,2.31-4.89,5.84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bs-2",
    "data-name": "bs",
    className: "cls-9-cookie-p3",
    d: "M612.35,958.02c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27ZM609.29,953.33c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bp-4",
    "data-name": "bp",
    className: "cls-9-cookie-p3",
    d: "M622.53,951.09c-2.65-.81-4.07.88-4.07,3.87v6.31h-3.4l-.07-12.9h3.19c.14.88-.07,1.97.2,2.72.41-1.9,1.83-3.6,4.14-2.78v2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "by-2",
    "data-name": "by",
    className: "cls-9-cookie-p3",
    d: "M630.68,961.07c-2.44.95-5.91.48-5.91-2.85v-7.6h-1.63v-2.24h1.83l1.02-3.06h2.1v3.06h2.44v2.24h-2.44v6.72c-.07,1.56,1.09,2.1,2.58,1.7v2.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bz-2",
    "data-name": "bz",
    className: "cls-9-cookie-p3",
    d: "M632.65,946.07v-2.51h3.4v2.51h-3.4ZM632.65,961.28v-12.9h3.4v12.9h-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bu-2",
    "data-name": "bu",
    className: "cls-9-cookie-p3",
    d: "M645.96,945.93c-1.83-.48-2.92.34-2.58,2.44h2.58v2.24h-2.58v10.66h-3.33v-10.66h-1.9v-2.24h1.9c-.61-4.01,2.17-5.5,5.91-4.62v2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bz-3",
    "data-name": "bz",
    className: "cls-9-cookie-p3",
    d: "M647.52,946.07v-2.51h3.4v2.51h-3.4ZM647.52,961.28v-12.9h3.4v12.9h-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bs-3",
    "data-name": "bs",
    className: "cls-9-cookie-p3",
    d: "M665.18,958.02c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27ZM662.12,953.33c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bt-3",
    "data-name": "bt",
    className: "cls-9-cookie-p3",
    d: "M672.17,948.1c2.1-.07,3.12,1.02,3.94,2.31l-.07-6.86h3.4l.07,17.72h-3.26c-.14-.68,0-1.56-.2-2.1-.75,1.56-1.97,2.38-4.14,2.38-3.53,0-4.62-3.06-4.69-6.72,0-3.8,1.29-6.59,4.96-6.72ZM673.32,959.24c2.24,0,2.72-2.04,2.78-4.48.07-2.51-.61-4.35-2.78-4.35s-2.58,2.04-2.65,4.41c0,2.92.88,4.41,2.65,4.41"
  }))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6-cookie-p3",
    d: "M1161.06,341.15l-.56,151.82-340.86,6.88"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2-cookie-p3",
    d: "M1161.56,341.17h-1v-.5h1v.5Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4-cookie-p3",
    d: "M804.88,500.15l14.16-4.92.2,9.26-14.36-4.34Z"
  })), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    id: "rect4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5-cookie-p3",
    d: "M460.5,1015.35c0-3.31,2.69-6,6-6h330.25c3.31,0,6,2.69,6,6v100c0,3.31-2.69,6-6,6h-330.25c-3.31,0-6-2.69-6-6v-100Z"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Q"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bJ",
    className: "cls-11-cookie-p3",
    d: "M509.24,1045.76c2.38.34,4.14,1.56,4.14,4.14,0,5.91-7.2,4.62-12.97,4.75v-16.84c5.16.2,12.02-1.15,12.02,4.07,0,2.24-1.29,3.4-3.19,3.87ZM502.65,1045.01c3.4-.07,7.47.61,7.47-2.85,0-3.19-4.28-2.44-7.47-2.51v5.36ZM502.65,1052.82c3.73-.14,8.42.95,8.42-3.06s-4.75-2.85-8.42-2.99v6.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aP-3",
    "data-name": "aP",
    className: "cls-11-cookie-p3",
    d: "M520.37,1054.93c-6.04.27-3.67-7.88-4.14-13.17h2.17v8.15c0,2.1.48,3.4,2.65,3.33,4.89-.14,3.06-6.86,3.4-11.48h2.1l.07,12.9h-2.04c-.07-.68.07-1.7-.14-2.24-.75,1.49-1.9,2.44-4.07,2.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aE-7",
    "data-name": "aE",
    className: "cls-11-cookie-p3",
    d: "M537.42,1044.95c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ae-13",
    "data-name": "ae",
    className: "cls-11-cookie-p3",
    d: "M542.1,1038.97v-2.04h2.17v2.04h-2.17ZM542.1,1054.66v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad-10",
    "data-name": "ad",
    className: "cls-11-cookie-p3",
    d: "M553.78,1041.48c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ah-11",
    "data-name": "ah",
    className: "cls-11-cookie-p3",
    d: "M566.21,1041.48c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM569.74,1046.98c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aE-8",
    "data-name": "aE",
    className: "cls-11-cookie-p3",
    d: "M582.16,1044.95c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aE-9",
    "data-name": "aE",
    className: "cls-11-cookie-p3",
    d: "M594.39,1044.95c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  })), /*#__PURE__*/React.createElement("g", {
    id: "R"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bK",
    className: "cls-11-cookie-p3",
    d: "M613.74,1037.61c5.5,0,8.35,3.12,8.35,8.56s-2.99,8.76-8.35,8.76-8.35-3.33-8.35-8.76,2.85-8.56,8.35-8.56ZM613.74,1053.03c4.28,0,6.04-2.78,6.04-6.86s-1.97-6.72-6.04-6.72-6.04,2.65-6.04,6.72,1.9,6.79,6.04,6.86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aF-2",
    "data-name": "aF",
    className: "cls-11-cookie-p3",
    d: "M637.23,1054.66h-2.44l-2.72-11.14-2.78,11.14h-2.44l-3.67-12.9h2.17l2.65,11.14,2.92-11.14h2.31l2.78,11.14,2.85-11.14h2.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad-11",
    "data-name": "ad",
    className: "cls-11-cookie-p3",
    d: "M648.77,1041.48c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ah-12",
    "data-name": "ah",
    className: "cls-11-cookie-p3",
    d: "M661.2,1041.48c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM664.73,1046.98c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aB-6",
    "data-name": "aB",
    className: "cls-11-cookie-p3",
    d: "M675.73,1043.59c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  })), /*#__PURE__*/React.createElement("g", {
    id: "S"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ag-7",
    "data-name": "ag",
    className: "cls-11-cookie-p3",
    d: "M692.43,1052.21c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM686.12,1051.06c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aD-4",
    "data-name": "aD",
    className: "cls-11-cookie-p3",
    d: "M702.21,1041.48c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM702.82,1043.11c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aC-2",
    "data-name": "aC",
    className: "cls-11-cookie-p3",
    d: "M717.35,1054.66h-2.58l-4.69-12.9h2.31l3.67,11.2,3.8-11.2h2.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ae-14",
    "data-name": "ae",
    className: "cls-11-cookie-p3",
    d: "M723.87,1038.97v-2.04h2.17v2.04h-2.17ZM723.87,1054.66v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aE-10",
    "data-name": "aE",
    className: "cls-11-cookie-p3",
    d: "M736.77,1044.95c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ah-13",
    "data-name": "ah",
    className: "cls-11-cookie-p3",
    d: "M746.62,1041.48c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM750.15,1046.98c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aE-11",
    "data-name": "aE",
    className: "cls-11-cookie-p3",
    d: "M762.58,1044.95c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  })), /*#__PURE__*/React.createElement("g", {
    id: "T"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aO-3",
    "data-name": "aO",
    className: "cls-11-cookie-p3",
    d: "M531.78,1071.84c-.68-1.9-2.38-3.06-4.96-3.06-4.01,0-5.91,2.72-5.91,6.72s1.97,6.86,6.04,6.86c2.92,0,4.21-1.63,5.3-3.53l1.83.95c-1.22,2.58-3.46,4.48-7.27,4.48-5.43,0-7.94-3.4-8.22-8.76-.41-7.06,6.72-10.39,12.7-7.54,1.29.61,2.1,1.77,2.65,3.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aP-4",
    "data-name": "aP",
    className: "cls-11-cookie-p3",
    d: "M540.67,1084.26c-6.04.27-3.67-7.88-4.14-13.17h2.17v8.15c0,2.1.48,3.4,2.65,3.33,4.89-.14,3.06-6.86,3.4-11.48h2.1l.07,12.9h-2.04c-.07-.68.07-1.7-.14-2.24-.75,1.49-1.9,2.44-4.07,2.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aE-12",
    "data-name": "aE",
    className: "cls-11-cookie-p3",
    d: "M557.72,1074.28c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "af-15",
    "data-name": "af",
    className: "cls-11-cookie-p3",
    d: "M564.78,1080.8c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ao-7",
    "data-name": "ao",
    className: "cls-11-cookie-p3",
    d: "M574.35,1070.82c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM574.29,1082.63c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aD-5",
    "data-name": "aD",
    className: "cls-11-cookie-p3",
    d: "M586.92,1070.82c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM587.53,1072.45c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ae-15",
    "data-name": "ae",
    className: "cls-11-cookie-p3",
    d: "M596.35,1068.3v-2.04h2.17v2.04h-2.17ZM596.35,1083.99v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ag-8",
    "data-name": "ag",
    className: "cls-11-cookie-p3",
    d: "M609.66,1081.55c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM603.35,1080.39c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad-12",
    "data-name": "ad",
    className: "cls-11-cookie-p3",
    d: "M621.61,1070.82c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  })), /*#__PURE__*/React.createElement("g", {
    id: "U"
  }, /*#__PURE__*/React.createElement("path", {
    id: "af-16",
    "data-name": "af",
    className: "cls-11-cookie-p3",
    d: "M638.05,1080.8c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ao-8",
    "data-name": "ao",
    className: "cls-11-cookie-p3",
    d: "M647.62,1070.82c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM647.55,1082.63c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  })), /*#__PURE__*/React.createElement("g", {
    id: "V"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bL",
    className: "cls-11-cookie-p3",
    d: "M670.91,1084.26c-5.57,0-8.22-3.26-8.49-8.76-.34-7.27,6.79-10.46,13.1-7.54,1.15.54,1.97,1.7,2.51,2.92l-2.17.61c-.88-1.7-2.51-2.72-5.16-2.72-4.14,0-5.98,2.65-5.98,6.72s1.97,6.79,6.18,6.86c2.38,0,4.21-.75,5.36-1.83v-3.06h-5.02v-1.9h7.13v5.84c-1.7,1.7-4.14,2.85-7.47,2.85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ao-9",
    "data-name": "ao",
    className: "cls-11-cookie-p3",
    d: "M687,1070.82c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM686.93,1082.63c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bM",
    className: "cls-11-cookie-p3",
    d: "M694.88,1078.42v-1.9h5.98v1.9h-5.98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bN",
    className: "cls-11-cookie-p3",
    d: "M703.91,1083.99v-16.84h2.24v15.01h8.49v1.83h-10.73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ae-16",
    "data-name": "ae",
    className: "cls-11-cookie-p3",
    d: "M717.08,1068.3v-2.04h2.17v2.04h-2.17ZM717.08,1083.99v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aC-3",
    "data-name": "aC",
    className: "cls-11-cookie-p3",
    d: "M728.15,1083.99h-2.58l-4.69-12.9h2.31l3.67,11.2,3.8-11.2h2.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ah-14",
    "data-name": "ah",
    className: "cls-11-cookie-p3",
    d: "M739.83,1070.82c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM743.36,1076.32c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  })))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6-cookie-p3",
    d: "M631.63,1122.35v48.37"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2-cookie-p3",
    d: "M632.13,1122.35h-1v-.5h1v.5Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4-cookie-p3",
    d: "M631.63,1185.49l-4.64-14.27h9.28l-4.64,14.27Z"
  })), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    id: "rect5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5-cookie-p3",
    d: "M460.5,1193.61c0-3.31,2.69-6,6-6h330.25c3.31,0,6,2.69,6,6v100c0,3.31-2.69,6-6,6h-330.25c-3.31,0-6-2.69-6-6v-100Z"
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "W"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aO-4",
    "data-name": "aO",
    className: "cls-11-cookie-p3",
    d: "M554.87,1235.07c-.68-1.9-2.38-3.06-4.96-3.06-4.01,0-5.91,2.72-5.91,6.72s1.97,6.86,6.04,6.86c2.92,0,4.21-1.63,5.3-3.53l1.83.95c-1.22,2.58-3.46,4.48-7.27,4.48-5.43,0-7.94-3.4-8.22-8.76-.41-7.06,6.72-10.39,12.7-7.54,1.29.61,2.1,1.77,2.65,3.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aS-2",
    "data-name": "aS",
    className: "cls-11-cookie-p3",
    d: "M565.25,1235.75c-4.89,0-2.99,6.93-3.33,11.48h-2.17v-17.72h2.17l-.07,6.99c.81-1.43,1.9-2.44,4.14-2.44,6.04,0,3.6,7.88,4.07,13.17h-2.17v-8.22c.14-2.17-.54-3.33-2.65-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ag-9",
    "data-name": "ag",
    className: "cls-11-cookie-p3",
    d: "M581.21,1244.78c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM574.9,1243.63c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad-13",
    "data-name": "ad",
    className: "cls-11-cookie-p3",
    d: "M593.16,1234.05c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bO",
    className: "cls-11-cookie-p3",
    d: "M610.82,1234.32c-.68,8.49,2.78,19.9-7.47,17.72-1.56-.41-2.58-1.36-2.99-2.92l2.17-.34c1.02,3.19,6.79,2.17,6.04-1.9v-2.04c-.75,1.43-1.97,2.44-4.14,2.44-3.67,0-4.62-2.78-4.62-6.52s1.09-6.59,4.82-6.65c1.97-.07,3.26,1.09,4.01,2.38.07-.68,0-1.56.14-2.17h2.04ZM605.18,1245.73c2.44,0,3.4-2.17,3.4-4.96s-.95-5.09-3.4-5.09c-2.65,0-3.12,2.31-3.12,5.09s.41,4.96,3.12,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ah-15",
    "data-name": "ah",
    className: "cls-11-cookie-p3",
    d: "M619.17,1234.05c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM622.7,1239.55c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aE-13",
    "data-name": "aE",
    className: "cls-11-cookie-p3",
    d: "M635.13,1237.52c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  })), /*#__PURE__*/React.createElement("g", {
    id: "X"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ag-10",
    "data-name": "ag",
    className: "cls-11-cookie-p3",
    d: "M654.54,1244.78c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM648.23,1243.63c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aB-7",
    "data-name": "aB",
    className: "cls-11-cookie-p3",
    d: "M666.29,1236.16c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ah-16",
    "data-name": "ah",
    className: "cls-11-cookie-p3",
    d: "M673.42,1234.05c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM676.95,1239.55c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Y"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aG-2",
    "data-name": "aG",
    className: "cls-11-cookie-p3",
    d: "M688.63,1247.23v-17.72h2.17v17.72h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ae-17",
    "data-name": "ae",
    className: "cls-11-cookie-p3",
    d: "M694,1231.54v-2.04h2.17v2.04h-2.17ZM694,1247.23v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aC-4",
    "data-name": "aC",
    className: "cls-11-cookie-p3",
    d: "M705.06,1247.23h-2.58l-4.69-12.9h2.31l3.67,11.2,3.8-11.2h2.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ah-17",
    "data-name": "ah",
    className: "cls-11-cookie-p3",
    d: "M716.74,1234.05c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM720.27,1239.55c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  })))), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6-cookie-p3",
    d: "M631.63,1300.61v55.47"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2-cookie-p3",
    d: "M632.13,1300.62h-1v-.5h1v.5Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4-cookie-p3",
    d: "M631.63,1370.85l-4.64-14.27h9.28l-4.64,14.27Z"
  })), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    id: "rect6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5-cookie-p3",
    d: "M460.5,1378.97c0-3.31,2.69-6,6-6h330.25c3.31,0,6,2.69,6,6v100c0,3.31-2.69,6-6,6h-330.25c-3.31,0-6-2.69-6-6v-100Z"
  }))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Z"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aj-2",
    "data-name": "aj",
    className: "cls-11-cookie-p3",
    d: "M535.01,1415.74c5.91.07,12.97-1.02,12.97,5.09,0,5.3-5.23,5.43-10.73,5.16v6.59h-2.24v-16.84ZM537.25,1424.23c3.87,0,8.42.75,8.42-3.4s-4.62-3.19-8.42-3.26v6.65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ao-10",
    "data-name": "ao",
    className: "cls-11-cookie-p3",
    d: "M556.06,1419.41c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM555.99,1431.23c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aE-14",
    "data-name": "aE",
    className: "cls-11-cookie-p3",
    d: "M572.01,1422.87c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "af-17",
    "data-name": "af",
    className: "cls-11-cookie-p3",
    d: "M579.07,1429.39c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  })), /*#__PURE__*/React.createElement("g", {
    id: "aa"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bL-2",
    "data-name": "bL",
    className: "cls-11-cookie-p3",
    d: "M598.36,1432.86c-5.57,0-8.22-3.26-8.49-8.76-.34-7.27,6.79-10.46,13.1-7.54,1.15.54,1.97,1.7,2.51,2.92l-2.17.61c-.88-1.7-2.51-2.72-5.16-2.72-4.14,0-5.98,2.65-5.98,6.72s1.97,6.79,6.18,6.86c2.38,0,4.21-.75,5.36-1.83v-3.06h-5.02v-1.9h7.13v5.84c-1.7,1.7-4.14,2.85-7.47,2.85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ao-11",
    "data-name": "ao",
    className: "cls-11-cookie-p3",
    d: "M614.45,1419.41c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM614.38,1431.23c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bM-2",
    "data-name": "bM",
    className: "cls-11-cookie-p3",
    d: "M622.33,1427.02v-1.9h5.98v1.9h-5.98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aG-3",
    "data-name": "aG",
    className: "cls-11-cookie-p3",
    d: "M630.95,1432.58v-17.72h2.17v17.72h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ae-18",
    "data-name": "ae",
    className: "cls-11-cookie-p3",
    d: "M636.31,1416.9v-2.04h2.17v2.04h-2.17ZM636.31,1432.58v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aC-5",
    "data-name": "aC",
    className: "cls-11-cookie-p3",
    d: "M647.38,1432.58h-2.58l-4.69-12.9h2.31l3.67,11.2,3.8-11.2h2.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ah-18",
    "data-name": "ah",
    className: "cls-11-cookie-p3",
    d: "M659.06,1419.41c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM662.59,1424.91c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ab"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aE-15",
    "data-name": "aE",
    className: "cls-11-cookie-p3",
    d: "M681.81,1422.87c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "af-18",
    "data-name": "af",
    className: "cls-11-cookie-p3",
    d: "M688.87,1429.39c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ah-19",
    "data-name": "ah",
    className: "cls-11-cookie-p3",
    d: "M698.44,1419.41c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM701.97,1424.91c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aA-2",
    "data-name": "aA",
    className: "cls-11-cookie-p3",
    d: "M713.04,1419.41c3.73.07,4.75,2.78,4.75,6.65s-1.09,6.65-4.75,6.79c-2.1,0-3.33-.88-4.07-2.31l.07,7.13h-2.17l-.07-17.99h2.1l.14,2.04c.68-1.43,1.9-2.31,4.01-2.31ZM712.5,1431.23c2.72,0,3.06-2.31,3.06-5.09s-.41-4.96-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aE-16",
    "data-name": "aE",
    className: "cls-11-cookie-p3",
    d: "M727.98,1422.87c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCookiePhase3);
export default __webpack_public_path__ + "static/media/Cookie_Phase_3.1741d8da1fc0becc12a7662b04c26638.svg";
export { ForwardRef as ReactComponent };